import { useSelector } from 'app-redux'
import { Config } from 'common/config'
import { RootState } from 'common/redux'
import { RoomAddress } from 'common/types'
import { useMemo } from 'react'
import { useSimpleGroupingApi } from './simple-grouping-api'
import { useSimpleGroupingTask } from './use-simple-grouping-task'

export type UseSimpleGrouping = {
	started: boolean
	start: (address: RoomAddress) => Promise<void>
	finish: (address: RoomAddress) => Promise<void>
}
export const useSimpleGrouping = (): UseSimpleGrouping => {
	const api = useSimpleGroupingApi(Config.beeldayBackendUrl)
	const task = useSimpleGroupingTask()
	const started = useSelector(
		(state: RootState) => state.simpleGrouping.started
	)

	return useMemo(
		() => ({
			started,
			// The task is bound here rather than at the call site: `start` reaches
			// the backend as an overwrite of the stored task, so a caller that
			// omits it blanks the task the room is working on.
			start: (address: RoomAddress) => api.start(address, task),
			finish: api.finish,
		}),
		[api, started, task]
	)
}
